import React, { useMemo, useState } from 'react';
import { DatePicker } from 'antd';
import { fromEventWallClock, toEventWallClock } from 'utils';

const EventDateTimePicker = ({ event, value, onChange, placeholder }) => {
	const [suggestedTime, setSuggestedTime] = useState(null);
	const wallClock = useMemo(() => (value ? toEventWallClock(event, value) : null), [event, value]);

	const handleChange = picked => onChange(picked ? fromEventWallClock(event, picked) : null);
	const handleOpenChange = open => setSuggestedTime(open ? toEventWallClock(event) : null);
	// antd skips onChange when OK confirms the unchanged suggested time, so commit it here
	const handleOk = picked => {
		if (!value) handleChange(picked);
	};

	return (
		<DatePicker
			value={wallClock ?? suggestedTime}
			placeholder={placeholder}
			onChange={handleChange}
			onOpenChange={handleOpenChange}
			onOk={handleOk}
			format="YYYY-MM-DD hh:mm a"
			showTime={{ use12Hours: true }}
			showNow={false}
			use12Hours
		/>
	);
};

export default EventDateTimePicker;
